export default "__VITE_ASSET__U7AaNB0l__"